var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"mr-4",on:{"click":function($event){_vm.dialog = true}}},[_vm._v(" Add Assessment ")]),_c('assessment-modal',_vm._b({on:{"closeDialog":_vm.closeDialog}},'assessment-modal',this.$data,false,true))],1)}
var staticRenderFns = []

export { render, staticRenderFns }